import ideal from "./ideal.svg.asset.json";
import trustly from "./trustly.svg.asset.json";
import sofort from "./sofort.svg.asset.json";
import applePay from "./apple-pay.svg.asset.json";
import googlePay from "./google-pay.svg.asset.json";
import skrill from "./skrill.svg.asset.json";
import neteller from "./neteller.svg.asset.json";
import paypal from "./paypal.svg.asset.json";
import paysafecard from "./paysafecard.svg.asset.json";
import hipay from "./hipay.png.asset.json";
import visa from "./visa.svg";
import creditcard from "./creditcard.svg";
import mastercard from "./mastercard.svg";
import klarna from "./klarna.svg";
import muchbetter from "./muchbetter.svg";
import neosurf from "./neosurf.png";
import revolut from "./revolut.svg";
import afterpay from "./afterpay-casinos.svg";
import idin from "./idin.svg";

/** Officiële merklogo's per betaalmethode (slug -> CDN-url). */
export const METHOD_LOGOS: Record<string, string> = {
  ideal: ideal.url,
  trustly: trustly.url,
  sofort: sofort.url,
  "apple-pay": applePay.url,
  "google-pay": googlePay.url,
  skrill: skrill.url,
  neteller: neteller.url,
  paypal: paypal.url,
  paysafecard: paysafecard.url,
  hipay: hipay.url,
  visa,
  mastercard,
  creditcard,
  klarna,
  muchbetter,
  neosurf,
  revolut,
  "afterpay-casinos": afterpay,
  idin,
};

export function getMethodLogo(slug: string): string | undefined {
  return METHOD_LOGOS[slug];
}
